import { render, staticRenderFns } from "./AuthorizedPersonFormView.vue?vue&type=template&id=bf9add68&"
import script from "./AuthorizedPersonFormView.vue?vue&type=script&lang=js&"
export * from "./AuthorizedPersonFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports